// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { CommercialAgreement } from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/CommercialAgreement';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import { useParties } from '../../../contexts/PartiesContext';
import TemplateContract from '../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../other/useQueryWithOptions';

export const useCommercialAgreements: () => UseQueryResult<
  TemplateContract<CommercialAgreement>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  return useQueryWithOptions({
    queryKey: ['queryCommercialAgreements', operator],
    queryFn: async (_, options) => {
      return ledgerApi.queryCommercialAgreements(options, operator);
    },
  });
};
